import { IBaseCategory } from '@getgreenline/homi-shared'
import * as React from 'react'
import { UncontrolledButtonDropdown, DropdownToggle, DropdownMenu } from 'reactstrap'

export interface IOption {
  id: string
  name: string
}

interface Props {
  name: string
  options: IOption[]
  selectedOptionIds: string[]
  onSelect: (optionId: string) => void
  selectAllOptions: () => void
  unselectAllOptions: () => void
}

interface State {
  searchTerm: string
}

export class FilterDropdown extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = {
      searchTerm: '',
    }
  }

  handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({ searchTerm: event.target.value })
  }

  handleSelect = (optionId: string) => {
    this.props.onSelect(optionId)
    this.setState({ searchTerm: '' })
  }

  render() {
    const { searchTerm } = this.state
    const { selectedOptionIds, options } = this.props

    const filteredOptions = options.filter((option) =>
      option.name.toLowerCase().includes(searchTerm.toLowerCase().trim()),
    )

    return (
      <UncontrolledButtonDropdown style={{ width: '100%' }}>
        <DropdownToggle caret color='light' style={{ textAlign: 'left' }}>
          {`${this.props.name} (${selectedOptionIds.length})`}
        </DropdownToggle>
        <DropdownMenu className='reactstrap-dropdown-menu'>
          <div className='ml-2 mr-2 p-2'>
            <div className='text-right w-100 mb-2'>
              <a className='mr-2' onClick={this.props.selectAllOptions}>
                All
              </a>
              <a onClick={this.props.unselectAllOptions}>None</a>
            </div>
            <input
              type='text'
              placeholder='Search'
              value={searchTerm}
              onChange={this.handleSearchChange}
              className='form-control mb-2'
            />
            {filteredOptions.map((option) => {
              return (
                <div key={option.id}>
                  <input
                    className='mr-2'
                    value={option.id}
                    type='checkbox'
                    checked={selectedOptionIds.includes(option.id)}
                    onChange={() => this.handleSelect(option.id)}
                  />
                  {option.name}
                </div>
              )
            })}
          </div>
        </DropdownMenu>
      </UncontrolledButtonDropdown>
    )
  }
}
